var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "map-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  }, [_c('h1', [_vm._v("MAP")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/rmg-map.png",
      "alt": "Map of the selected artworks at Ace Hotel London"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e279a64c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapPage.vue
// module id = 6Pgi
// module chunks = 1